import React from 'react';
import { translate, Trans } from 'react-i18next';
import {Link} from 'react-router-dom';
import {Button, Form, Input, Grid, Message, Modal, Label, Segment} from 'semantic-ui-react';

import ConfirmGroupSwitch from './ConfirmGroupSwitch.js';
import LoadInline from 'modules/loading/LoadInline.js';
import {withError} from 'modules/misc/ErrorPage.js';
import Utils from 'utils/Utils.js';
import {colors, shadow, spacings, fonts, layout} from 'style';
import styleDef from './style.js';

var style = {
    ...styleDef,
    content: {
        ...fonts.body,
        lineHeight: '1.5',
        minHeight: '100%',
        maxWidth: layout.screenWidth,
        marginLeft: 'auto',
        marginRight: 'auto',
        color: colors.themeDarkerGrey,
        backgroundColor: 'white',
        boxShadow: layout.screenShadow,
    },
    contentDiv: {
        maxWidth: '500px',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    noCollapse: {
        height: '0.01px',
    },
    header: {
        ...fonts.h2,
        lineHeight: '1.5',
        textAlign: 'center',
        color: colors.themeBlue,
        margin: spacings.large,
    },
    subheader: {
        ...fonts.h4,
        lineHeight: '1.5',
        color: colors.themeBlue,
        margin: spacings.base,
    },
    description: {
        ...fonts.bodyL,
        textAlign: 'center',
        margin: spacings.large,
    },
    warning: {
        ...fonts.bodyL,
        textAlign: 'center',
        margin: spacings.large,
        color: colors.warningRed,
    },
    optionRow: {
        cursor: 'pointer',
        margin: spacings.base,
        borderBottom: '1 px solid grey',
        height: '61px',
        lineHeight: '61px',
    },
    optionRowContent: {
        lineHeight: '61px',
    },
    optionImage: {
        float: 'left',
        textAlign: 'center',
        width: '61px',
        height: '61px',
        lineHeight: '61px',
        border: '0px solid ' + colors.themeDarkGrey,
        borderRadius: '8px',
        boxShadow: shadow,
        marginRight: spacings.small,
        marginLeft: spacings.small,
        backgroundPosition:'50% 50%', 
        backgroundSize:'cover',
    },
    groupIcon: {
        color: colors.themeTeal,
        fontSize: '30px',
        margin: '0',
        width: '30px',
        height: '30px',
        display: 'inline',
    },
    noGroupIcon: {
        color: colors.themeBlue,
        position: 'relative',
        top: '2px',
    },
    rightArrow: {
        float: 'right',
        fontWeight: 'bold',
        color: colors.themeDarkGrey,
    },
    optionName: {
        ...fonts.body,
        color: colors.themeDarkerGrey,
    },
    optionDescription: {
        ...fonts.bodyS,
        color: colors.themeDarkGrey,
    },
};

const OptionRow = ({children, name, imageUrl, onClick}) => (
    <div style={style.optionRow} onClick={onClick}>
        <div style={{...style.optionImage, backgroundImage:Utils.url(imageUrl)}}>{children}</div>
        <i style={style.rightArrow} className='icon-arrow-right' />
        <div style={style.optionRowContent}>
            <div style={style.optionName}>{name}</div>
        </div>
    </div>
);

const GroupSelect = ({t,
                      companies,
                      consumer,
                      busy,
                      isSwitch,
                      error,
                      switchCompanyError,
                      showConfirm,
                      onConfirm,
                      onCancel,
                      comapnies,
                      onSelectInvite,
                      onShowEnterGroupCode,
                      onHideError}) => (
    <div style={style.content}>
        {busy && 
        <div style={style.contentDiv}>
            <LoadInline centered vcentered /> 
        </div>
        }
        {!busy && 
        <div style={style.contentDiv}>
            <div style={style.noCollapse} />

            {!isSwitch &&
                <div style={style.header}>{t('join_a_group')}</div>
            }

            <div style={style.description}>{Utils.endlToBr(t('join_group_message'))}</div>

            {isSwitch &&
                <div style={style.warning}>{Utils.endlToBr(t('switch_group_warning'))}</div>
            }

            {Boolean(companies && companies.length>0) &&
            <div>
                <div style={style.subheader}>{t('your_inviations')}</div>

                {companies.map(company=>(
                    <OptionRow key={company.id} 
                               name={company.name} 
                               imageUrl={Utils.deref(company, 'companyWelcome.logo.url')}
                               onClick={()=>onSelectInvite(company.code)}>
                </OptionRow>
                ))}
                
                <br />
            </div>
            }

            <div style={style.subheader}>{t('group_codes')}</div>
            <OptionRow name={t('enter_group_code')} 
                       onClick={onShowEnterGroupCode}>
                <i style={style.groupIcon} className="users icon"/>
            </OptionRow>
            <br />

            {consumer &&
            <div>
                <div style={style.subheader}>{t('no_group_code')}</div>
                <OptionRow name={t('try_optimity_lite')} 
                           onClick={()=>onSelectInvite(consumer.code)}>
                    <i style={{...style.groupIcon, ...style.noGroupIcon}} className="icon-arrow-right"/>
                </OptionRow>
                <br />
            </div>
            }
        </div> 
        }
        {switchCompanyError &&
            <Modal closeIcon open onClose={onHideError}>
                <Modal.Content>
                    <Message negative>{String(switchCompanyError)}</Message>
                </Modal.Content>
            </Modal>
        }
        {showConfirm &&
            <ConfirmGroupSwitch onClose={onCancel} onConfirm={onConfirm}/>
        }
    </div>
);

export default withError(translate('authentication')(GroupSelect));



// WEBPACK FOOTER //
// ./src/modules/authentication/GroupSelect.js